import { Injectable } from "@angular/core";
import { DataService } from "../../core/services/data.service";
import { ActivityResultSettingDto } from "../models/activity/activity-result-setting-dto";
import { ActivityResultSettingListItem } from "../models/activity/activity-result-setting-list-item";
import { HttpClient } from "@angular/common/http";
import { NotificationService } from "../../core/services/notification.service";

@Injectable()
export class ActivityResultSettingsService extends DataService<ActivityResultSettingListItem, ActivityResultSettingDto> {
    
    constructor(http: HttpClient, notificationService: NotificationService) {
        super(http, notificationService);
        this.controllerName = 'activity-result-settings';
    }
}